export default __webpack_public_path__ + "static/media/bear.b8b10992.ogg";